module.exports = __webpack_public_path__ + "static/Wojtek.0a7505ff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Wojtek.jpg
// module id = 690
// module chunks = 263791100135453